import { AxDropdown } from "@axess/limestone";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { AxCounter } from "../../Limestone/AxCounter/AxCounter";
import { Product } from "../../Models/Tickets/Product";
import { BodyUtility } from "../AxUtility/BodyUtility";
import { AxLoad } from "../../Lib/AxSystem/AxLoad";
import { PackageMinMaxConstraint, CheckMinMaxConstraintResult } from "../../Modules/Packages/PackageMinMaxConstraint";
import { BestMatchHandler } from "../BestMatch/BestMatchHandler";
import { BehaviorSubject } from "rxjs";
import { CrossSaleSelectionHelper, ICrossSaleSelectionOptions } from "../../Lib/Helper/AxProdSelection/CrossSaleSelectionHelper";

export class TicketList {
    private CultureInfo: any;
    private Divisor: number;

    public ProductList: Product[];

    public Total: string;
    public ProductDropdown: AxDropdown = new AxDropdown();
    public foreignCurrency: string;

    public Counter: AxCounter[] = [];

    public QuantityOkSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public QuantityChange: BehaviorSubject<number> = new BehaviorSubject<number>(0);

    public allotmentQuantity: number;

    private ticketTypeNo: number;
    private poolNo: number;
    private dateFrom: moment.Moment;

    private bestMatchHandler: BestMatchHandler;

    // cross-sale ticket: maximum total quantity and discount of the displayed total (see CrossSaleSelectionHelper)
    private crossSaleMaxQuantity: number;
    private crossSaleDiscountPercent: number;
    private counterMaxes: number[] = [];

    constructor(private _I18nHelper = new I18nHelper(),
        private _BodyUtility = new BodyUtility()) { }

    Init(initData: InitData): void {
        this.CultureInfo = initData.CultureInfo;
        this.Divisor = initData.NumberDivisor;
        this.ProductList = initData.ProductList;
        this.foreignCurrency = initData.ForeignCurrency;
        this.allotmentQuantity = initData.AllotmentAvailable ?? -1;
        this.crossSaleMaxQuantity = initData.CrossSaleMaxQuantity;
        this.crossSaleDiscountPercent = initData.CrossSaleDiscountPercent;

        this.ProductDropdown.init('.prod_selection__prod-selection .ax-dropdown');

        this.ticketTypeNo = initData.Id;
        this.poolNo = initData.ProductGroupIdentifier;

        // a cross-sale ticket is never transformed into a best match package in the cart, so its best match is not shown
        this.bestMatchHandler = new BestMatchHandler(initData.GetBestMatch && !initData.IsCrossSale, this.Divisor, "div.prod_selection__betterMatch_holder", "div.prod_selection__betterMatch_packageName_holder",
            "div.prod_selection__betterMatch_betterPrice_holder", "span.prod_selection__original_SinglePrice", "div.prod_selection__calculatedPrice");

        $('.prod_selection__date-selection').click(x => {
            $('.prod_selection__date-wrapper').addClass('active');
            this._BodyUtility.DisableScroll();
        });

        $('.prod_selection__prod-selection').click(x => {
            $('.prod_selection__prod-wrapper').addClass('active');
            this._BodyUtility.DisableScroll();
        });

        $('.prod_selection__prod-continue').click(x => {
            $('.prod_selection__prod-wrapper').removeClass('active');
            $('.prod_selection__date-wrapper').addClass('active');
        });

        $('.prod_selection__prod-wrapper .prod_selection__prod-close').click(x => {
            $('.prod_selection__prod-wrapper').removeClass('active');
            this._BodyUtility.EnableScroll();
        });

        $('.prod_selection__date-wrapper .prod_selection__prod-close').click(x => {
            $('.prod_selection__date-wrapper').removeClass('active');
            this._BodyUtility.EnableScroll();
        });

        $('.tv4_quantity__info_expand').click(x => {
            $('.tv4_quantity__info').toggleClass('active');
        });

        for (let prod of this.ProductList) {
            prod.ListElement = $('.prod_selection__prod-list')[prod.Id];

            let axCounter = new AxCounter();
            axCounter.Init({
                Value: prod.Quantity,
                Selector: `.prod__counter_${prod.Id}`,
                Max: prod.Max,
                Min: prod.Min,
            });
            axCounter.Subscribe((x) => {
                prod.Quantity = x;
                // synchronously, before the counter updates its own buttons
                CrossSaleSelectionHelper.limitTotalQuantity(this.Counter, this.counterMaxes, this.crossSaleMaxQuantity);
                this.AdjustTotalAmount();
            });
            this.Counter.push(axCounter);
            this.counterMaxes.push(prod.Max);
        }
        CrossSaleSelectionHelper.limitTotalQuantity(this.Counter, this.counterMaxes, this.crossSaleMaxQuantity);
        this.AdjustTotalAmount();
    }

    SetFromDate(dateFrom: moment.Moment) {
        this.dateFrom = dateFrom;
    }

    AdjustTotalAmount(updateBasePrice?: boolean) {
        let totalAmount: number = 0;
        let totalAmountFrc: number = 0;
        let quantity: number = 0;
        let namedProducts: string = '';
        let foreignCurrency: boolean = false;
        // cross-sale discount (cents) of the first selected ticket
        let crossSaleDiscount: number = 0;
        let crossSaleDiscountFrc: number = 0;
        updateBasePrice = updateBasePrice || false;

        this.bestMatchHandler.GetBestMatchTicketsV4Date(this.ticketTypeNo, this.poolNo, this.dateFrom, this.ProductList).then((bestMatchResultList) => {

            for (let prod of this.ProductList) {

                if (prod.Quantity > 0) {
                    quantity += prod.Quantity;

                    let bestMatchResult = this.bestMatchHandler.FindBestMatch(prod.Id, bestMatchResultList);

                    if (bestMatchResultList.length > 0) {
                        totalAmount += this.bestMatchHandler.GetBestMatchProductPriceSum(prod.Quantity, prod.Price, bestMatchResult);
                    } else {
                        totalAmount += (prod.Quantity * this.GetPrice(prod.Price));
                    }

                    if (this.crossSaleDiscountPercent && !crossSaleDiscount) {
                        const ticketPrice = bestMatchResultList.length > 0 && bestMatchResult?.countUnmatched == 0 ? bestMatchResult.betterTariffInt : prod.Price;
                        crossSaleDiscount = CrossSaleSelectionHelper.getTicketDiscount(ticketPrice, prod.MandatoryArticlesPrice, this.crossSaleDiscountPercent);
                        crossSaleDiscountFrc = prod.ForeignPrice != null && prod.Price ? crossSaleDiscount * prod.ForeignPrice / prod.Price : 0;
                    }

                    namedProducts += `${prod.Quantity} ${prod.Name}, `;
                }

                $(prod.ListElement).find(`*[data-quantity-selection=${prod.Id}]`).html(prod.Quantity.toString());
                $(prod.ListElement).find(`*[data-quantity-input=${prod.Id}]`).val(prod.Quantity.toString());

                let price = $.number((prod.Quantity * this.GetPrice(prod.Price)), this.CultureInfo.currencyDecimalDigits, this.CultureInfo.currencyDecimalSeparator, this.CultureInfo.currencyGroupSeparator);
                $(prod.ListElement).find(`*[data-calculated-price=${prod.Id}]`).html(price.toString());

                if (prod.ForeignPrice != null) {
                    let priceFrc = $.number((prod.Quantity * this.GetPrice(prod.ForeignPrice)), this.CultureInfo.currencyDecimalDigits, this.CultureInfo.currencyDecimalSeparator, this.CultureInfo.currencyGroupSeparator);
                    $(prod.ListElement).find(`*[data-calculated-price-frc=${prod.Id}]`).html(`${this.foreignCurrency} ${priceFrc.toString()}`);
                    foreignCurrency = true;
                    totalAmountFrc += (prod.Quantity * this.GetPrice(prod.ForeignPrice));
                }

                if (updateBasePrice) {
                    $(prod.ListElement).find(`*[data-base-price=${prod.Id}]`).html(this.GetPriceString(this.GetPrice(prod.Price)));

                    if (prod.ForeignPrice != null) {
                        $(prod.ListElement).find(`*[data-base-price-frc=${prod.Id}]`).html(`${this.foreignCurrency} ${this.GetPriceString(this.GetPrice(prod.ForeignPrice))}`);
                    }
                }
            }

            namedProducts = namedProducts.substr(0, namedProducts.length - 2);

            totalAmount -= this.GetPrice(crossSaleDiscount);
            totalAmountFrc -= this.GetPrice(crossSaleDiscountFrc);

            let totalPrice: string = this.GetPriceString(totalAmount);
            this.Total = totalPrice;

            let summaryText = quantity.toString();

            if (quantity == 1) {
                summaryText += ` ${this._I18nHelper.GetTranslation(Translations.Ticket)}`;
            } else {
                summaryText += ` ${this._I18nHelper.GetTranslation(Translations.Tickets)}`;
            }

            let quantityOK: boolean = quantity > 0 && (this.allotmentQuantity === -1 || this.allotmentQuantity >= quantity);

            this.QuantityOkSubject.next(quantityOK);
            this.QuantityChange.next(quantity);


            let checkMinMaxConstraintResult = new CheckMinMaxConstraintResult();

            let minMaxConstraintModule = AxLoad.GetModule<PackageMinMaxConstraint>('PackageMinMaxConstraint');

            if (minMaxConstraintModule != null) {
                checkMinMaxConstraintResult = minMaxConstraintModule.CheckMinMaxConstraint(quantity);
            } else {
                checkMinMaxConstraintResult.minMaxOk = true;
            }

            if (quantityOK && checkMinMaxConstraintResult.minMaxOk) {
                this.ProductDropdown.setValue(namedProducts);
                $('.prod_selection__prod-continue').removeAttr('disabled');
                $('.prod_selection__prod-continue').html(this._I18nHelper.GetTranslation(Translations.Next));
            } else {
                this.ProductDropdown.resetSelection();
                $('.prod_selection__prod-continue').attr('disabled', 'disabled');

                if (!checkMinMaxConstraintResult.minMaxOk) {
                    $('.prod_selection__prod-continue').html(checkMinMaxConstraintResult.errorMessage);
                } else {
                    $('.prod_selection__prod-continue').html(this._I18nHelper.GetTranslation(Translations.Next));
                }
            }

            $('.prod_selection__persontype-summary').html(summaryText);
            $('.prod_selection__calculated-sum').html(totalPrice);

            if (foreignCurrency) {
                let totalPriceFrc: string = this.GetPriceString(totalAmountFrc);
                $('.prod_selection__calculated-sum-frc').html(`${this.foreignCurrency} ${totalPriceFrc}`);
            }
        }).catch(function () { });
    }

    GetQuantity() {
        let quantity = 0;
        for (let prod of this.ProductList) {
            quantity += prod.Quantity;
        }

        return quantity;
    }

    GetPriceString(totalAmount: number) {
        return $.number(totalAmount, this.CultureInfo.currencyDecimalDigits, this.CultureInfo.currencyDecimalSeparator, this.CultureInfo.currencyGroupSeparator)
    }

    GetPriceStringWithCurrencySymbol(totalAmount: number) {
        return `${this.CultureInfo.CurrencyPosition == 0 ? this.CultureInfo.CurrencySymbol : ''}${this.GetPriceString(totalAmount)}${this.CultureInfo.CurrencyPosition == 1 ? this.CultureInfo.CurrencySymbol : ''}`
    }

    GetPrice(price: number): number {
        return price / this.Divisor;
    }
}

export interface InitData extends ICrossSaleSelectionOptions {
    CultureInfo: any;
    NumberDivisor: number;
    ProductList: Product[];
    ProjNr: number;
    ProductGroupIdentifier: number;
    Id: number;
    ForeignCurrency: string;
    AllotmentAvailable: number;
    GetBestMatch: boolean;
}
